/**
 * Centralized configuration module
 * All environment-specific configuration should be accessed through this module
 *
 * Environment variables are set in:
 * - .env.development (npm start / npm run dev)
 * - .env.production (npm run build)
 * - .env.local (local overrides, not committed)
 *
 * Note: Vite requires VITE_ prefix for environment variables
 */

interface Config {
  apiBaseUrl: string;
  googleMapsApiKey: string;
  windcaveProxyUrl: string;
  webAppUrl: string;
  documentsUrl: string;
  isDevelopment: boolean;
  isProduction: boolean;
  isTest: boolean;
}

const config: Config = {
  // API Base URL for the booking web service
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:8880/RDLWebService/ws/bookings/',

  // Google Maps API Key
  googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '',

  // Windcave Payment Gateway Proxy URL
  windcaveProxyUrl: import.meta.env.VITE_WINDCAVE_PROXY_URL || '',

  // Web Application URL (used for payment callbacks)
  webAppUrl: import.meta.env.VITE_WEB_APP_URL || 'http://localhost:3000/',

  // Documents Service URL
  documentsUrl: import.meta.env.VITE_DOCUMENTS_URL || '',

  // Environment detection
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
  isTest: import.meta.env.MODE === 'test',
};

// Validate required configuration in production
if (config.isProduction) {
  const requiredVars: (keyof Config)[] = ['apiBaseUrl', 'googleMapsApiKey', 'windcaveProxyUrl', 'webAppUrl'];
  requiredVars.forEach(varName => {
    if (!config[varName]) {
      console.error(`Missing required configuration: ${varName}`);
    }
  });
}

export default config;
